import classes from './fdpScreen.module.scss';
import line_chart from '../../assets/icons/line_chart.svg';
import handShake from '../../assets/icons/handshakeIcon.svg';
import constrained from '../../assets/icons/contrained.svg';
import unconstrained from '../../assets/icons/unconstrained.svg';
import provisionalForecast from '../../assets/icons/provisionalForecast.svg';

import { useNavigate } from 'react-router-dom';
import { screenDataInterface } from 'Interfaces/navigationScreenDataInterface';
import { observer } from 'mobx-react';
import { useStore } from 'hooks/useStore';

const FDPScreen = () => {
  const navigate = useNavigate();
  const { FeatureFlagStore } = useStore();

  const flagEnabled = (key: string) => !FeatureFlagStore.isLoaded || FeatureFlagStore.isEnabled(key);

  const screenData: screenDataInterface = [
    {
      location: 'target_market',
      img: line_chart,
      label: 'Sales Plan',
      disabled: !flagEnabled('fdp.tms'),
    },
    {
      location: 'unconstrained_forecast',
      img: unconstrained,
      label: 'Unconstrained Forecast',
      disabled: !flagEnabled('fdp.unconstrained_forecast'),
    },
    {
      location: 'constrained_forecast',
      img: constrained,
      label: 'Constrained Forecast',
      disabled: !flagEnabled('fdp.constrained_forecast'),
    },
    {
      location: 'supplier_forecast',
      img: handShake,
      label: 'Supplier Forecast',
      disabled: !flagEnabled('fdp.supplier_forecast'),
    },
    {
      location: 'provisonal_forecast',
      img: provisionalForecast,
      label: 'Provisional Forecast',
      disabled: !flagEnabled('fdp.provisional_forecast'),
    },
    {
      location: 'ooc',
      img: line_chart,
      label: 'Out of Cycle',
      disabled: false,
      // disabled: !flagEnabled('fdp.ooc'),
    },
  ];

  return (
    <div className={classes.fdpScreenContainer}>
      {screenData.filter(data => !data.disabled).map((data, index) => (
        <div onClick={() => navigate(data.location)} key={index}>
          <div className={classes.btnSection}>
            <div>
              <div className={classes.imgBackground}></div>
              <img src={data.img} alt={`${data.label} icon`} />
            </div>
            <p>{data.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default observer(FDPScreen);
